<template>
    <v-menu
        v-model="datePicker"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="dateFormatted"
                :label="label"
                :error-messages="formError(errors, errorKey)"
                prepend-inner-icon="mdi-calendar"
                persistent-hint
                hint="TT.MM.JJJJ"
                :readonly="false"
                v-on="on"
                v-bind="attrs"
                clearable
                autocomplete="false"
                @click:clear="$nextTick(() => handleInput = null)"
            />
        </template>
        <v-date-picker
            locale="de-ch"
            :allowed-dates="allowedDates"
            :first-day-of-week="1"
            v-model="handleInput"
            @input="datePicker = false"
        />
    </v-menu>
</template>

<script>

import DatesMixin from '@/mixins/dates';

export default {
    name: 'DatePicker',
    mixins: [ DatesMixin ],
    props: {
        value: {
            type: String,
            default: '',
        },
        allowedDates: {
            type: Function,
            default: val => true
        },
        clearable: {
            type: Boolean,
            default: true,
        },
        label: {
            type: String,
            default: '',
        },
        errorKey: {
            type: String,
            default: '',
        },
        errors: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            datePicker: false,
            dateValue: this.value,
        }
    },
    computed: {
        /*dateFormatted() {
            return this.formatDate(this.dateValue);
        },*/
        dateFormatted: {
            get() {
                return this.formatDate(this.dateValue);
            },
            set(newValue) {
                if (!/^\d{1,2}.\d{1,2}.\d{4}$/.test(newValue)) {
                    return;
                }
                const dateParts = newValue.split('.');
                let newDate;
                try {
                    newDate = new Date(`${dateParts[ 2 ]}-${dateParts[ 1 ]}-${dateParts[ 0 ]}`);
                } catch (e) {
                    return;
                }
                if (newDate instanceof Date && !isNaN(newDate)) {
                    this.handleInput = this.formatDateISO(newDate);
                }
            }
        },
        handleInput: {
            get() {
                return this.dateValue;
            },
            set(newValue) {
                this.dateValue = newValue;
                this.$emit('input', this.dateValue)
            }
        },
    },
    watch: {
        value(val) {
            this.dateValue = val;
        },
    },
};
</script>
